import type { UseFormProps, UseFormReturn } from 'react-hook-form'
import { useForm } from 'react-hook-form'
import type { Schema } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'

export interface UseCustomFormProps extends UseFormProps {
  schema?: Schema
}

export const useCustomForm = (
  options: UseCustomFormProps = {}
): UseFormReturn => {
  const { schema, ...restOptions } = options

  if (!schema && !restOptions.resolver) {
    throw new Error('useCustomForm requires a schema')
  }

  return useForm({
    resolver: zodResolver(schema!),
    mode: 'onChange',
    ...restOptions
  })
}
